import {ConnectionInterface} from "../Interface/ConnectionInterface";
import {ProviderModel} from "./ProviderModel";

export const ConnectionModel: ConnectionInterface = {
    domain: "",
    id: "",
    name: "",
    provider: ProviderModel
}
